<template>
  <v-data-table
    :headers="headers"
    :items="driedCookingProcessChecks"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="DriedCookingProcessCheck-button-new"
          @click="$router.push({
            name: 'dried-cooking-process-check-EditDriedCookingProcessCheck'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'dried-cooking-process-check-EditDriedCookingProcessCheck',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListDriedCookingProcessCheck',
  module: 'DriedCookingProcessCheck',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('driedCookingProcessChecks', ['driedCookingProcessChecks']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('date'),
          value: 'date',
        },
        {
          text: this.$$t('receivingDate'),
          value: 'receivingDate',
        },
        {
          text: this.$$t('farm'),
          value: 'farm',
        },
        {
          text: this.$$t('cookingDate'),
          value: 'cookingDate',
        },
        {
          text: this.$$t('kgReceived'),
          value: 'kgReceived',
        },
        {
          text: this.$$t('sizeRange'),
          value: 'sizeRange',
        },
        {
          text: this.$$t('meatWeight'),
          value: 'meatWeight',
        },
        {
          text: this.$$t('potOneTimeIn'),
          value: 'potOneTimeIn',
        },
        {
          text: this.$$t('potOneTimeOut'),
          value: 'potOneTimeOut',
        },
        {
          text: this.$$t('potOneTimeTemp'),
          value: 'potOneTimeTemp',
        },
        {
          text: this.$$t('potOneTimeComments'),
          value: 'potOneTimeComments',
        },
        {
          text: this.$$t('potTwoTimeIn'),
          value: 'potTwoTimeIn',
        },
        {
          text: this.$$t('potTwoTimeOut'),
          value: 'potTwoTimeOut',
        },
        {
          text: this.$$t('potTwoTimeTemp'),
          value: 'potTwoTimeTemp',
        },
        {
          text: this.$$t('potTwoTimeComments'),
          value: 'potTwoTimeComments',
        },
        {
          text: this.$$t('potTwoTimeIn'),
          value: 'potTwoTimeIn',
        },
        {
          text: this.$$t('potTwoTimeOut'),
          value: 'potTwoTimeOut',
        },
        {
          text: this.$$t('potTwoTimeTemp'),
          value: 'potTwoTimeTemp',
        },
        {
          text: this.$$t('potThreeTimeIn'),
          value: 'potThreeTimeIn',
        },
        {
          text: this.$$t('potThreeTimeOut'),
          value: 'potThreeTimeOut',
        },
        {
          text: this.$$t('potThreeTimeTemp'),
          value: 'potThreeTimeTemp',
        },
        {
          text: this.$$t('potThreeTimeComments'),
          value: 'potThreeTimeComments',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_driedCookingProcessChecks();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('driedCookingProcessChecks', ['LOAD_driedCookingProcessChecks', 'DELETE_driedCookingProcessCheck']),
    /** Delete DriedCookingProcessCheck from the collection
     */
    async remove(DriedCookingProcessCheck) {
      this.isLoading = true;
      await this.DELETE_DriedCookingProcessCheck(DriedCookingProcessCheck);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# DriedCookingProcessCheck example

'''js
<DriedCookingProcessCheck />
'''
</docs>
